import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { fromEvent, merge, Subject } from 'rxjs';
import { debounceTime, tap, throttleTime } from 'rxjs/operators';
import js_beautify from 'js-beautify';
import { createPatch } from 'diff';
import { environment } from '../../../../../photographer-panel/src/environments/environment';

let mouseMove = [];

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class ScreenRecordModule {
  mutated = new Subject();
  headMutated = new Subject();
  lastContent = { BODY: null, HEAD: null };

  constructor() {
    if (!environment.production) {
      return;
    }
    // const target = window.open('/assets/test.html', null);
    // console.log('Screen Record INITED');
    const targetNode = document.body;
    const config = { attributes: true, childList: true, subtree: true };
    const takeSnapshot = (element: HTMLElement) => {
      const newContent = js_beautify.html_beautify(
        element.innerHTML
          .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
          .replace(/<!--(.*?)-->/gms, '')
      );
      // console.log(!!this.lastContent[element.nodeName]);
      if (!!this.lastContent[element.nodeName]) {
        // target.postMessage(
        //   {
        //     type: 'diff' + element.nodeName,
        //     diff: createPatch(
        //       'dada',
        //       this.lastContent[element.nodeName],
        //       newContent
        //     ),
        //   },
        //   '*'
        // );
      } else {
        // target.postMessage(
        //   { type: 'html' + element.nodeName, newContent },
        //   '*'
        // );
      }
      // console.log(target);

      this.lastContent[element.nodeName] = newContent;
    };
    window.addEventListener('DOMContentLoaded', (event) => {
      setTimeout(() => {
        const observer = new MutationObserver((r) => {
          r.filter(({ addedNodes }) => addedNodes.length).forEach(
            ({ addedNodes }) => {
              addedNodes.forEach(checkInputs);
            }
          );
          this.mutated.next(undefined);
        });
        // target.postMessage(
        //   {
        //     type: 'window-size',
        //     width: window.innerWidth,
        //     height: window.innerHeight,
        //   },
        //   '*'
        // );
        fromEvent(window, 'resize', { capture: true, passive: true })
          .pipe(debounceTime(500))
          .subscribe(() => {
            // target.postMessage(
            //   {
            //     type: 'window-size',
            //     width: window.innerWidth,
            //     height: window.innerHeight,
            //   },
            //   '*'
            // );
          });
        const checkInputs = (node: HTMLElement) => {
          if (!!node.querySelectorAll) {
            (node as HTMLElement)
              .querySelectorAll('input,textarea')
              .forEach((element: HTMLInputElement) => {
                // console.log(element, element.value);
                if (!!element.value) {
                  // console.log('POST MESSAGE');
                  setTimeout(() => {
                    // target.postMessage(
                    //   {
                    //     type: 'input-value',
                    //     input: unique(element),
                    //     value: element.value,
                    //   },
                    //   '*'
                    // );
                  }, 500);
                }
              });
          }
        };

        checkInputs(document.body);

        const headObserver = new MutationObserver((r) => {
          this.headMutated.next(undefined);
        });
        observer.observe(targetNode, config);
        headObserver.observe(
          document.body.parentElement.querySelector('head'),
          config
        );
        const head = document.body.parentElement.querySelector('head');
        this.mutated
          .pipe(
            debounceTime(100),
            tap(() => takeSnapshot(document.body))
          )
          .subscribe(() => {
            // console.log('repainted');
            const newContent = js_beautify.html_beautify(
              document.body.innerHTML
                .replace(
                  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
                  ''
                )
                .replace(/<!--(.*?)-->/gms, '')
            );
            if (!!this.lastContent.BODY) {
              if (newContent !== this.lastContent.BODY) {
                takeSnapshot(document.body);
              }
            }
            if (!!!this.lastContent.HEAD) {
              takeSnapshot(head);
            }
          });
        this.headMutated
          .pipe(
            tap(() => takeSnapshot(head)),
            debounceTime(500)
          )
          .subscribe(() => {
            // console.log('HEAD MUTATED');
          });

        fromEvent<MouseEvent>(window, 'mousemove', { passive: true })
          .pipe(
            tap(({ pageX, pageY }) =>
              mouseMove.push([new Date().getTime(), pageX, pageY])
            ),
            throttleTime(100)
          )
          .subscribe(() => {
            // console.log('SEND MOUSE');
            // target.postMessage({ type: 'mouse-move', move: mouseMove }, '*');
            mouseMove = [];
          });

        fromEvent<MouseEvent>(window, 'click', { passive: true }).subscribe(
          ({ pageX, pageY }) => {
            // target.postMessage(
            //   {
            //     type: 'mouse-click',
            //     click: [new Date().getTime(), pageX, pageY],
            //   },
            //   '*'
            // );
            mouseMove.push([new Date().getTime(), pageX, pageY]);

            // target.postMessage({ type: 'mouse-move', move: mouseMove }, '*');
            mouseMove = [];
          }
        );
        merge(
          fromEvent<any>(window, 'keyup', { passive: true }),
          fromEvent<any>(window, 'blur', { passive: true, capture: true }),
          fromEvent<any>(window, 'focus', { passive: true, capture: true }),
          fromEvent<any>(window, 'focus', { passive: true, capture: true }),
          fromEvent<any>(window, 'input', { passive: true, capture: true }),
          fromEvent<any>(window, 'change', { passive: true, capture: true })
        ).subscribe((e: { target: HTMLInputElement }) => {
          // Node.
          // console.log('FORM EVENET', event);
          if (['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
            // console.log(unique(e.target), e.target.value);
            // target.postMessage(
            //   {
            //     type: 'input-value',
            //     input: unique(e.target),
            //     value: e.target.value,
            //   },
            //   '*'
            // );
          }
        });

        fromEvent<any>(window, 'scroll', { capture: true }).subscribe((e) => {
          // Node.
          // console.log(e.target.scrollTop);
          // target.postMessage(
          //   {
          //     type: 'scroll',
          //     input: unique(e.target),
          //     top: e.target.scrollTop,
          //     left: e.target.scrollLeft,
          //   },
          //   '*'
          // );
        });
      }, 1000);
    });
  }
}
